import availableJobCategories from '@/helpers/availableJobCategoriesHelper'

export default function() {
    return {
        profiles: [],
        fields: [
            {
                key: 'averageRate',
                label: 'Avaliação média'
            },
            {
                key: 'name',
                label: 'Nome'
            },
            {
                key: 'category',
                label: 'Categoria'
            },
            {
                key: 'totalRatings',
                label: 'Total de avaliações'
            },
            {
                key: 'actions',
                label: 'Ações'
            }
        ],
        availableJobCategories: [
            {
                label: 'Todas',
                code: null
            },
            ...availableJobCategories
        ],
        itemsPerPage: 15,
        totalPages: 0,
        currentPage: 1,
        filters: {
            category: null
        }
    }
}
